export default "__VITE_ASSET__BrbBFyMf__"